import React from 'react';
import ReactHtmlParser from 'react-html-parser';

export const ConnectSection = ({
  bgImg,
  title,
  description,
  buttonTitle,
  buttonUrl
}) => {
  return (
    <section className="section info_mod center_level_mod double_decor_mod">
      <div className="section_bg loaded_mod" style={{ backgroundImage: `url(${bgImg})` }} />
      <div className="section_in limit_mod">
        <div className="section_block">
          <h2 className="section_title offset_mod">{ReactHtmlParser(title)}</h2>
          <div className="section_descr offset_mod darken_mod">{description}</div>
          <a className="btn_base" href={buttonUrl}>{buttonTitle}</a>
        </div>
      </div>
    </section>
  );
}
export default ConnectSection;